import React, { useState, useEffect } from 'react';
import './LoadingScreen.css';

const LIGHT_LOGO_SRC = '/updated%20dark%20mode%20logo.png';
const DARK_LOGO_SRC = '/updated%20dark%20mode%20logo.png';

export default function LoadingScreen({ ready }) {
  const [fadeOut, setFadeOut] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!ready) return;
    setFadeOut(true);
    const t = setTimeout(() => setHidden(true), 700);
    return () => clearTimeout(t);
  }, [ready]);

  if (hidden) return null;

  return (
    <div className={`loading-screen${fadeOut ? ' fade-out' : ''}`}>
      <div className="loading-screen__logo-wrap visible">
        <div className="loading-screen__ring" />
        <img
          src={LIGHT_LOGO_SRC}
          alt=""
          className="loading-screen__banner loading-screen__banner--light"
          draggable={false}
        />
        <img
          src={DARK_LOGO_SRC}
          alt=""
          className="loading-screen__banner loading-screen__banner--dark"
          draggable={false}
        />
      </div>
    </div>
  );
}
